import { ILLProduct, ILLSignature, ILLGenericKeys, ILLCompany, ILLEstablishment, ISplValidation, ILLBusinessCategory, IFdaCenter} from './index';


export class ILLFormDetail {
    llId: string;
    llRevisionId: string;
    setId: string;
    createDate: Date;
    businessCategoryId: string;
    registrantConfidentiality: string;
    createUser: string;
    effectiveDate: Date;
    countryRegion: string;
    formatedVersion: string;
    formName: string;
    isDraftMode: boolean;
    proprietaryName: string;
    proprietaryNameSuffix: string;
    establishedGenericName: string;
    labelerCompanyRevisionId: string;
    minorRevision: number;
    majorVersion: number;
    splVersion: string;
    title: string;
    splTitle: string;
    ndcProductCode: string;
    sourceNDCCode: string;
    estGenName: string;
    deaSchedule: string;
    dosageForm: string;
    dosageFormId: number;
    deaScheduleId: number;
    productTypeId: number;
    serviceType: ILLGenericKeys;
    signature: ILLSignature;
    products: ILLProduct[];
    establishments: ILLEstablishment[];
    labelerCompany: ILLCompany;
    registrantCompany: ILLCompany;
    activeFlag: boolean;
    modifiedByUser: string;
    ndcLabelerCode: string;
    splServiceType: ILLGenericKeys;
    splRevisionDate: string;
    businessCategory: ILLBusinessCategory;
    validationMessages: ISplValidation;
    modifiedByDate: Date;
    effectiveTime: Date;
    fdaCenter: IFdaCenter;
}

